import React from 'react';
import { MobileLife } from '../../FinancialPlan/Insurance/Life/LifeContainer';
import { MobileLongTermCare } from '../../FinancialPlan/Insurance/LongTermCare/LongTermCareContainer';
import { MobileDisability } from '../../FinancialPlan/Insurance/Disability/DisabilityContainer';

import { LIFE, DISABILITY, LONG_TERM_CARE } from '../../FinancialPlan/Insurance/InsuranceConstants';

const Components = {
  [LIFE]: MobileLife,
  [LONG_TERM_CARE]: MobileLongTermCare,
  [DISABILITY]: MobileDisability,
};

const MobileInsuranceView = (props) => {
  const {
    selectedSection,
    insuranceGoal,
  } = props;
  if (!insuranceGoal) {
    return null;
  }
  const SpecificInsuranceView = Components[selectedSection];

  return (
    <div className="NewFinancialPlan_Insurance">
      <SpecificInsuranceView {...props} />
    </div>
  );
};

export default MobileInsuranceView;
